import { gql } from '@apollo/client';

export const SetCurrentLapMutation = gql`
    mutation SetCurrentLap($id: ID!, $platform: Platform) {
        setCurrentLap(id: $id, platform: $platform)
    }
`;
